<template>
    <div class="container">
        <h1>{{ $t('coaching') }}</h1>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: "Coaching",
};
</script>
